import { createPlugin, createRoutableExtension } from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const configEditorPlugin = createPlugin({
  id: 'config-editor',
  routes: {
    root: rootRouteRef,
  },
});

export const ConfigEditorPage = configEditorPlugin.provide(
  createRoutableExtension({
    name: 'ConfigEditorPage',
    component: () => import('./components/ConfigEditorPage').then(m => m.ConfigEditorPage),
    mountPoint: rootRouteRef,
  }),
);
